export default __webpack_public_path__ + "static/media/forgot-pw-confirmation.0033be03.svg";